module.exports = __webpack_public_path__ + "img/tag_front.e5298461.svg";